import SideMenu from "./SideMenu";
import type { SideMenuProps } from "./SideMenu.d";

export { SideMenu };
export type { SideMenuProps };
